<template>
  <div>
    <div class="row justify-content-between">
      <div class="col-12">
        <div class="row mb-3">
          <select
            
            class="form-control form-control-sm mx-2"
            v-model="params.event_id"
            @change="getDataCategory()"
          >
            <option v-for="event in events" :value="event.id" :key="event.id">
              {{ event.event_name }}
            </option>
          </select>
          <select
            
            class="form-control form-control-sm mx-2 mt-2"
            v-model="params.category_id"
            @change="getDataTahapBalap()"
          >
            <option v-for="category in categories" :value="category.id" :key="category.id">
              {{ category.name }}
            </option>
          </select>

          <select
            class="form-control form-control-sm mx-2 mt-2"
            v-model="params.tahap_balap"
            @change="getDataBatch()"
          >
            <option v-for="tahap_balap in tahap_balaps" :value="tahap_balap.id" :key="tahap_balap.id">
              {{ tahap_balap.nama_tahap }}
            </option>
          </select>

          <select
            class="form-control form-control-sm mx-2 mt-2"
            v-model="params.batch"
            @change="getDataTahapBalap()"
          >
            <option v-for="batch in batches" :value="batch.id" :key="batch.id">
              Batch {{ batch.nomor_batch }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Tahapan Balap -->
    <CCard v-for="(tahap_balap, index_tahap_balap) in tahap_balaps" :key="tahap_balap.id">
      <CCardBody>
        <div class="row">
          <div class="col-md-8">
            <b>{{ tahap_balap.nama_tahap }}</b>
            <!-- Tahapan Balap: <b>{{ tahap_balap.nama_tahap }}</b> |
            Urutan Balap: <b>{{ tahap_balap.urutan_tahap }}</b> |
            Jumlah Batch: <b>{{ tahap_balap.jumlah_batch }}</b> |
            Moto Per Batch: <b>{{ tahap_balap.moto_per_batch }}</b> |
            Lolos Per Batch: <b>{{ tahap_balap.lolos_per_batch }}</b> -->
          </div>
          <div class="col-md-4" style="text-align: right;">
            <button
              class="btn btn-sm btn-primary ml-2"
              @click="addModalBatch(tahap_balap)"
            >
              <CIcon name="cilMedicalCross" />
              Buat Batch
            </button>
            <button
              class="btn btn-sm btn-secondary ml-2"
              @click="editModal(tahap_balap)"
            >
              Edit Tahapan Balap
            </button>
            <button
              class="btn btn-sm btn-danger ml-2"
              @click="deleteTahapBalap(tahap_balap)"
            >
              Hapus Tahapan Balap
            </button>
          </div>
        </div>

        <hr />

        <div v-for="(batch, index_batch) in tahap_balap.batches" :key="batch.id">
          <div class="row">
             <div class="col-md-8">
                Batch: <b>{{ batch.nomor_batch }}</b> |
                Status: <b>{{ batch.status_batch }}</b> 
                <!-- | Kapasitas Gate: <b>{{ batch.kapasitas_gate }}</b> |
                Waktu Mulai: <b>{{ batch.waktu_mulai_aktual }}</b> |
                Waktu Selesai: <b>{{ batch.waktu_selesai_aktual }}</b> -->
             </div>
             <div class="col-md-4" style="text-align: right;">
              <button 
                class="btn btn-sm btn-secondary ml-2"
                @click="editModalBatch(batch)"
              >
                Edit Batch
              </button>
              <button 
                class="btn btn-sm btn-danger ml-2"
                @click="deleteBatch(batch)"
              >
                Hapus Batch
              </button>
             </div>
          </div>  

          <hr />
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Nama</th>
                  <th>Plat Number</th>
                  <th>GM1</th>
                  <th v-if="tahap_balap.moto_per_batch > 1">GM2</th>
                  <th v-if="tahap_balap.moto_per_batch > 2">GM3</th>
                  <th>M1</th>
                  <th v-if="tahap_balap.moto_per_batch > 1">M2</th>
                  <th v-if="tahap_balap.moto_per_batch > 2">M3</th>
                  <th>Total</th>
                  <th>Tambahan</th>
                  <th>Grandtotal</th>
                  <th>Rank</th>
                  <th v-if="tahap_balap.urutan_tahap > 1">El POS</th>
                  <th v-if="tahap_balap.urutan_tahap > 1">El Group</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(registran, index) in batch.registran_batches" :key="registran.id">
                  <!-- <td>{{ registran.registran ? registran.registran.fullname : 'Available Slot' }}</td> -->

                  <td>
                    <v-select
                        placeholder="Pilih Peserta"
                        :options="computedRegistran"
                        label="label"
                        :reduce="item => item.value"
                        v-model="registran.registran_id"
                        @input="onPesertaSelected(index_tahap_balap, index_batch, index)"
                      />
                  </td>

                  <td style="width: 80px;">{{ registran.registran ? registran.registran.plat_number : '-' }}</td>

                  <!-- Input GM1–GM3 -->
                  <td style="width: 70px;">
                    <input style="width: 70px;"
                      type="number"
                      class="form-control"
                      v-model.number="registran.gm1"
                      min="1"
                      :max="batch.kapasitas_gate"
                    />
                  </td>
                  <td style="width: 70px;" v-if="tahap_balap.moto_per_batch > 1">
                    <input style="width: 70px;"
                      type="number"
                      class="form-control"
                      v-model.number="registran.gm2"
                      min="1"
                      :max="batch.kapasitas_gate"
                    />
                  </td>
                  <td style="width: 70px;" v-if="tahap_balap.moto_per_batch > 2">
                    <input style="width: 70px;"
                      type="number"
                      class="form-control"
                      v-model.number="registran.gm3"
                      min="1"
                      :max="batch.kapasitas_gate"
                    />
                  </td>
                  <td style="width: 70px;">
                    <input style="width: 70px;"
                      type="number"
                      class="form-control"
                      v-model.number="registran.m1"
                      min="1"
                      :max="batch.kapasitas_gate"
                      @input="hitungTotal(index_tahap_balap, index_batch, index)"
                    />
                  </td>
                  <td style="width: 70px;"  v-if="tahap_balap.moto_per_batch > 1">
                    <input style="width: 70px;"
                      type="number"
                      class="form-control"
                      v-model.number="registran.m2"
                      min="1"
                      :max="batch.kapasitas_gate"
                      @input="hitungTotal(index_tahap_balap, index_batch, index)"
                    />
                  </td>
                  <td style="width: 70px;" v-if="tahap_balap.moto_per_batch > 2">
                    <input style="width: 70px;"
                      type="number"
                      class="form-control"
                      v-model.number="registran.m3"
                      min="1"
                      :max="batch.kapasitas_gate"
                      @input="hitungTotal(index_tahap_balap, index_batch, index)"
                    />
                  </td>
                  <td style="width: 70px;">
                    <input style="width: 70px;"
                      type="number"
                      class="form-control"
                      :class="{ 'text-danger': isDuplicateTotalPoint(index_tahap_balap, index_batch, registran.total_point) }"
                      v-model.number="registran.total_point"
                      min="1"
                      :max="batch.kapasitas_gate"
                      readonly
                    />
                  </td>
                  <td style="width: 70px;">
                    <input style="width: 70px;"
                      class="form-control"
                      v-model="registran.tambahan"
                      @input="updateTambahan(index_tahap_balap, index_batch, index)"
                    />
                  </td>
                  <td style="width: 70px;">
                    <input style="width: 70px;"
                      class="form-control"
                      v-model="registran.grandtotal"
                      readonly
                    />
                  </td>
                  <td style="width: 70px;">
                    <input style="width: 70px;"
                      type="number"
                      class="form-control"
                      v-model="registran.total_poin_batch_lolos"
                      readonly
                    />
                  </td>
                   <td style="width: 70px;" v-if="tahap_balap.urutan_tahap > 1">
                    <input style="width: 70px;"
                      class="form-control"
                      v-model="registran.el_pos"
                      @input="processData(index_tahap_balap, index_batch, index)"
                    />
                  </td>
                  <td style="width: 70px;" v-if="tahap_balap.urutan_tahap > 1">
                    <input style="width: 70px;"
                      type="number"
                      class="form-control"
                      v-model="registran.el_group"
                      @input="processData(index_tahap_balap, index_batch, index)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-3 mb-4" style="text-align: right;">
            <button v-if="batch.registran_batches < batch.kapasitas_gate"
              class="btn btn-sm btn-primary ml-2"
              @click="addModalRegistran(batch, tahap_balap)"
            >
              <CIcon name="cilMedicalCross" />
              Tambahkan Peserta
            </button>

            <button 
              class="btn btn-sm btn-primary ml-2"
              @click="sendWhatsapp(index_tahap_balap, index_batch)"
            >
              Kirim Whatsapp
            </button>

            <button v-if="tahap_balap.urutan_tahap > 1"
              class="btn btn-sm btn-primary ml-2"
              @click="generateResult(index_tahap_balap, index_batch)"
            >
              Generate Hasil
            </button>

            <!-- <button 
              class="btn btn-sm btn-primary ml-2"
              @click="startBatch(batch)"
            >
              Start Batch
            </button>
              <button 
              class="btn btn-sm btn-primary ml-2"
              @click="processResult(batch)"
            >
              Process Result & Qualify
            </button>
            <template v-if="batch.status !== 'TERJADWAL' || batch.status !== 'SELESAI' ">
              <button 
                v-for="motoNum in tahap_balap.moto_per_batch"
                :key="'submit-' + motoNum"
                class="btn btn-sm btn-primary ml-2"
                :disabled="!batch || !batch.registran_batches"
                @click="submitMotoResults(batch, motoNum)"
              >
                Submit Moto {{ motoNum }}
              </button>
            </template> -->
          </div>

        </div>
      </CCardBody>
    </CCard>

    <CModal
      size="lg"
      :title="
        isUpdate ? 'Edit Tahap Balap' : 'Tambah Tahap Balap'
      "
      centered
      :color="isUpdate ? 'success' : 'primary'"
      :show.sync="createModal"
    >
      <div class="row">
        <div class="col-12">
          <CInput
            v-model="form.nama_tahap"
            label="Nama Tahapan Balap"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.urutan_tahap"
            label="Urutan Tahapan Balap"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.jumlah_batch"
            label="Jumlah Batch"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.moto_per_batch"
            label="Moto Per Batch"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.lolos_per_batch"
            label="Lolos Per Batch"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.last_tahap_balap_id"
            label="Urutan tahap balap sebelumnya"
            placeholder="ketik disini"
          />
        </div>
      </div>
      <template slot="footer">
        <div>
          <button @click="cancel" class="btn btn-secondary mr-3">Batal</button>
          <button @click="submit" v-if="!isUpdate" class="btn btn-primary">
            Simpan
          </button>
          <button @click="update" v-if="isUpdate" class="btn btn-primary">
            Update
          </button>
        </div>
      </template>
    </CModal>


    <CModal
      size="lg"
      :title="
        isUpdateBatch ? 'Edit Batch' : 'Tambah Batch'
      "
      centered
      :color="isUpdateBatch ? 'success' : 'primary'"
      :show.sync="createModalBatch"
    >
      <CInput
        v-model="batch.nomor_batch"
        label="Nomor Bacth"
        placeholder="ketik disini"
      />
      <CInput
        v-model="batch.kapasitas_gate"
        label="Kapasitas Gate"
        placeholder="ketik disini"
      />
      <template slot="footer">
        <div>
          <button @click="cancel" class="btn btn-secondary mr-3">Batal</button>
          <button @click="submitBatch" v-if="!isUpdateBatch" class="btn btn-primary">
            Simpan
          </button>
          <button @click="updateBatch" v-if="isUpdateBatch" class="btn btn-primary">
            Update
          </button>
        </div>
      </template>
    </CModal>
  
    <CModal
      size="xl"
      :title="
        isUpdateRegistran ? 'Edit Peserta' : 'Tambah Peserta'
      "
      centered
      :color="isUpdateRegistran ? 'success' : 'primary'"
      :show.sync="createModalRegistran"
    >
      <table class="table table-bordered">
        <thead>
          <tr >
            <td style="width: 80px;">No</td>
            <td>Nama</td>
            <td v-for="i in form.moto_per_batch" :key="i">
              GM{{ i }}
            </td>
            <td style="width: 80px;">El-POS</td>
            <td style="width: 80px;">El-Group</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowIndex) in tableData" :key="rowIndex">
            <td style="width: 80px;">{{ rowIndex + 1 }}</td>
            <td>
              <v-select 
                placeholder="Pilih Peserta"
                :options="computedRegistran"
                label="label"
                :reduce="item => item.value"
                v-model="row.registran_id"
              />
            </td>
            <td v-for="(_, colIndex) in form.moto_per_batch" :key="colIndex" style="width: 80px;">
              <CInput v-model="row.moto_gate_starts[colIndex]" placeholder="Ketik disini" style="width: 80px;" />
            </td>
            <td>
              <CInput type="number" v-model="row.el_pos" placeholder="Ketik disini" style="width: 80px;" />
            </td>
            <td>
              <CInput type="number" v-model="row.el_group" placeholder="Ketik disini" style="width: 80px;" />
            </td>
          </tr>
        </tbody>
      </table>

      <template slot="footer">
        <div>
          <button @click="assignToBatch"  class="btn btn-primary">
            Assign to Batch
          </button>
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      registran: null,
      tahap_balaps: [],
      events: [],
      categories: [],
      batches: [],
      items: [],
      user: JSON.parse(localStorage.getItem("user")),
      params: {
        sorttype: "desc",
        sortby: "id",
        row: 100,
        page: 1,
        keyword: "",
        category_id: "",
        event_id: ""
      },
      isUpdate: false,
      createModal: false,
      form: {
        category_id: '',
        nama_tahap: '',
        urutan_tahap: '',
        jumlah_batch: '',
        moto_per_batch: 0,
        lolos_per_batch: ''
      },
      isUpdateBatch: false,
      createModalBatch: false,
      isUpdateRegistran: false,
      createModalRegistran: false,
      batch: {
        tahap_balap_id: '', 
        nomor_batch: '',
        kapasitas_gate: 0,
        status_batch: "TERJADWAL"
      },
      assignToBatches : [],
      tableData: []
    };
  },
  methods: {
    deleteTahapBalap(tahap_balap) {
      this.$swal.fire({
        icon: 'warning',
        text: 'Apakah anda yakin akan menghapus tahap balap ini?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Hapus',
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          var loading = this.$loading.show()
          this.$store
            .dispatch("race/deleteTahapBalap", tahap_balap.id)
            .then(() => {
              this.$toast.success("Berhasil menghapus data ")
              this.getDataTahapBalap(this.params.category_id);
              loading.hide()
            })
            .catch((e) => {
              this.$toast.error(e)
              loading.hide()
            })
        } 
      })
    },
    deleteBatch(batch) {
      this.$swal.fire({
        icon: 'warning',
        text: 'Apakah anda yakin akan menghapus batch ini?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Hapus',
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          var loading = this.$loading.show()
          this.$store
            .dispatch("race/deleteBatch", batch.id)
            .then(() => {
              this.$toast.success("Berhasil menghapus data ")
              this.getDataTahapBalap(this.params.category_id);
              loading.hide()
            })
            .catch((e) => {
              this.$toast.error(e)
              loading.hide()
            })
        } 
      })
    },
    onPesertaSelected(indexTahap, indexBatch, index) {
      const registranBatch = this.tahap_balaps[indexTahap].batches[indexBatch].registran_batches[index];
      const peserta = this.items.find(p => p.id === registranBatch.registran_id);
      
      if (peserta) {
        // Set data registran (selain ID)
        this.$set(registranBatch, 'registran', peserta);
        this.hitungTotal(indexTahap, indexBatch, index);
      } else {
        // Kosongkan jika tidak ada yang dipilih
        this.$set(registranBatch, 'registran', null);
      }
    },
    generateResult(index_tahap_balap, index_batch) {
      const batch = this.tahap_balaps[index_tahap_balap].batches[index_batch];
      batch.category_id = this.params.category_id;
      this.$store
        .dispatch("race/generateResult", batch)
        .then(() => {
          this.$toast.success("Berhasil di update!");
          this.getDataTahapBalap(this.params.category_id);
        })
        .catch((error) => {
          this.$toast.error(error);
        });
    },
    nextRace(index, data) {
      console.log(index, data, "hasil")
    }, 
    sendWhatsapp(index_tahap_balap, index_batch) {
      const batch = this.tahap_balaps[index_tahap_balap].batches[index_batch];

      this.$store
        .dispatch("race/sendWhatsapp", batch)
        .then(() => {
          this.$toast.success("Berhasil di update!");
        })
        .catch((error) => {
          this.$toast.error(error);
        });
    },
    updateTambahan(index_tahap_balap, index_batch, index) {
      const registran = this.tahap_balaps[index_tahap_balap].batches[index_batch].registran_batches[index];

      const total = parseFloat(registran.m1 || 0) +
                    parseFloat(registran.m2 || 0) +
                    parseFloat(registran.m3 || 0);

      const tambahan = parseFloat(registran.tambahan || 0);

      registran.total_point = total;
      registran.grandtotal = parseFloat((total + tambahan).toFixed(2));

      // ✅ Update ranking tanpa reset tambahan
      this.updateRankByGrandTotal(index_tahap_balap, index_batch);

      // Simpan data ke backend (jika perlu)
      this.processData(index_tahap_balap, index_batch);
    },
    updateRankByGrandTotal(index_tahap_balap, index_batch) {
      const registranList = this.tahap_balaps[index_tahap_balap].batches[index_batch].registran_batches;

      const sorted = registranList.slice().sort((a, b) => a.grandtotal - b.grandtotal);

      let currentRank = 1;
      let prevGrand = null;
      let sameRankCount = 0;

      sorted.forEach((r, idx) => {
        if (prevGrand === r.grandtotal) {
          sameRankCount++;
        } else {
          currentRank = idx + 1;
          sameRankCount = 1;
          prevGrand = r.grandtotal;
        }

        r.total_poin_batch_lolos = currentRank;
      });
    },
    processData(index_tahap_balap, index_batch) {
      const batch = this.tahap_balaps[index_tahap_balap].batches[index_batch];

      this.$store
        .dispatch("race/submitRegistranBatch", batch)
        .then(() => {
          this.$toast.success("Berhasil di update!");
        })
        .catch((error) => {
          this.$toast.error(error);
        });
    },
    applyTieBreaker(index_tahap_balap, index_batch, index_registran) {
      const registranList = this.tahap_balaps[index_tahap_balap].batches[index_batch].registran_batches;

      // ⛔ Reset semua tambahan jadi 0 dulu
      registranList.forEach(r => {
        r.tambahan = 0;
        r.grandtotal = r.total_point; // pastikan grandtotal balik ke total asli dulu
      });

      // Kelompokkan berdasarkan total_point yang sama
      const grouped = {};

      registranList.forEach(r => {
        const key = r.total_point;
        if (!grouped[key]) {
          grouped[key] = [];
        }
        grouped[key].push(r);
      });

      Object.values(grouped).forEach(group => {
        if (group.length <= 1) return;

        // Urutkan berdasarkan m3 jika ada, kalau tidak pakai m2
        const sorted = group.slice().sort((a, b) => {
          const aCheck = a.m3 ? parseFloat(a.m3) : parseFloat(a.m2);
          const bCheck = b.m3 ? parseFloat(b.m3) : parseFloat(b.m2);
          return aCheck - bCheck; // terkecil ke terbesar
        });

        // Tambahkan skor berdasarkan urutan
        sorted.forEach((r, i) => {
          const bonus = i === 0 ? 0 : parseFloat((i * 0.1).toFixed(2));
          const totalPoint = parseFloat(r.total_point) || 0;
          r.tambahan = bonus;
          r.grandtotal = parseFloat((totalPoint + bonus).toFixed(2));
        });
      });

      // Setelah selesai tie breaker, hitung ranking berdasarkan grandtotal
      const sortedByGrandTotal = registranList
        .slice()
        .sort((a, b) => a.grandtotal - b.grandtotal); // sekarang: terkecil ke terbesar

      let currentRank = 1;
      let prevGrand = null;
      let sameRankCount = 0;

      sortedByGrandTotal.forEach((r, idx) => {
        if (prevGrand === r.grandtotal) {
          sameRankCount++;
        } else {
          currentRank = idx + 1;
          sameRankCount = 1;
          prevGrand = r.grandtotal;
        }

        // Simpan ranking ke total_point_batch_lolos
        r.total_poin_batch_lolos = currentRank;
      });

      // simpan data ke backend
      this.processData(index_tahap_balap, index_batch);
    },
    isDuplicateTotalPoint(index_tahap_balap, index_batch, target_point) {
      const registran_batches = this.tahap_balaps[index_tahap_balap].batches[index_batch].registran_batches;

      // Hitung berapa banyak registran yang punya total_point yang sama
      const count = registran_batches.filter(registran => {
        return parseFloat(registran.total_point) === parseFloat(target_point);
      }).length;

      // Kalau ada lebih dari 1, berarti duplikat
      return count > 1;
    },
    hitungTotal(index_tahap_balap, index_batch, index) {
      if (index !== -1) {
        const m1 = parseFloat(this.tahap_balaps[index_tahap_balap].batches[index_batch].registran_batches[index].m1) || 0;
        const m2 = parseFloat(this.tahap_balaps[index_tahap_balap].batches[index_batch].registran_batches[index].m2) || 0;
        const m3 = parseFloat(this.tahap_balaps[index_tahap_balap].batches[index_batch].registran_batches[index].m3) || 0;
        const tambahan = parseFloat(this.tahap_balaps[index_tahap_balap].batches[index_batch].registran_batches[index].tambahan) || 0;

        const total = m1 + m2 + m3;
        const grand = total + tambahan;

        this.tahap_balaps[index_tahap_balap].batches[index_batch].registran_batches[index].total_point = total;
        this.tahap_balaps[index_tahap_balap].batches[index_batch].registran_batches[index].grandtotal = grand;

        this.applyTieBreaker(index_tahap_balap, index_batch, index);
      }
    },
    getTotalPoin(motos) {
      return motos.reduce((sum, moto) => {
        return sum + (Number(moto.posisi_akhir_moto) || 0);
      }, 0);
    },
    processResult(batch) {
      var loading = this.$loading.show();
      this.$store
        .dispatch("race/processResult", batch)
        .then(() => {
          this.$toast.success("Berhasil di rubah!");
          loading.hide();
          this.createModalRegistran = false;
          this.getDataTahapBalap(this.params.category_id);
        })
        .catch(() => {
          loading.hide();
        });
    },
    startBatch(batch) {
      var loading = this.$loading.show();
      this.$store
        .dispatch("race/startBatch", batch)
        .then(() => {
          this.$toast.success("Race Siap dimulai!");
          loading.hide();
          this.createModalRegistran = false;
          this.getDataTahapBalap(this.params.category_id);
        })
        .catch(() => {
          loading.hide();
        });
    },
    submitMotoResults(batch, motoNum) {
      const results = batch.registran_batches
        .map((registran) => {
          const moto = this.getMoto(registran.hasil_motos, motoNum);
          if (!moto) return null;

          return {
            registran_id: registran.registran.id,
            posisi_akhir_moto: moto.posisi_akhir_moto,
            waktu_tempuh: moto.waktu_tempuh,
            poin: moto.poin ?? null,
          };
        })
        .filter(Boolean);

      // (Optional) Hitung poin otomatis
      results.sort((a, b) => a.posisi_akhir_moto - b.posisi_akhir_moto);
      results.forEach((r, i) => r.poin = i + 1);

      const payload = {
        nomor_moto: motoNum,
        results,
        batch_id: batch.id
      };

      var loading = this.$loading.show();
      this.$store
        .dispatch("race/recordMotoResult", payload)
        .then(() => {
          this.$toast.success("Berhasil menambahkan data");
          loading.hide();
          this.createModalRegistran  = false;
          // this.getEvents();
        })
        .catch(() => {
          loading.hide();
        });
    },
    assignToBatch() {
      const registran_ids = this.tableData.map(row => row.registran_id);
      const el_pos = this.tableData.map(row => row.el_pos);
      const el_group = this.tableData.map(row => row.el_group);
      const moto_gate_starts = [];

      // Anggap jumlah kolom = form.moto_per_batch
      for (let col = 0; col < this.form.moto_per_batch; col++) {
        const colData = this.tableData.map(row => row.moto_gate_starts[col]);
        moto_gate_starts.push(colData);
      }

      const result = {
        batch_id: this.batch.id,
        registran_ids,
        moto_gate_starts,
        el_group,
        el_pos
      };

      var loading = this.$loading.show();
      this.$store
        .dispatch("race/assignRegistran", result)
        .then(() => {
          this.$toast.success("Berhasil menambahkan data");
          loading.hide();
          this.createModalRegistran = false;
          this.getDataTahapBalap(this.params.category_id);
        })
        .catch(() => {
          loading.hide();
        });

      // lanjut kirim via axios atau emit event
    },
    addModalRegistran(batch, tahap_balap) {
      this.batch = batch;
      this.form = tahap_balap;
      this.tableData = Array.from({ length: this.batch.kapasitas_gate }, () => ({
        registran_id: null,
        moto_gate_starts: Array(this.form.moto_per_batch).fill(null)
      }));
      this.createModalRegistran = true;
    },
    getRegistran() {
      var loading = this.$loading.show();
      this.$store
        .dispatch("registran/getRegistran", this.params)
        .then((resp) => {
          this.items = resp.data.data;
          loading.hide();
        })
        .catch((e) => {
          this.$toast.error("gagal mengambil data  \n", e);
          loading.hide();
        });
    },
    updateBatch() {
      var loading = this.$loading.show();
      this.$store
        .dispatch("race/editBatch", this.batch)
        .then(() => {
          this.$toast.success("Berhasil merubah data");
          loading.hide();
          this.createModalBatch = false;
          this.batch = {
            tahap_balap_id: '', 
            nomor_batch: '',
            kapasitas_gate: '',
            status_batch: "TERJADWAL"
          }
          this.getDataTahapBalap(this.params.category_id);
        })
        .catch(() => {
          loading.hide();
        });
    },
    submitBatch() {
      var loading = this.$loading.show();
      this.$store
        .dispatch("race/addBatch", this.batch)
        .then(() => {
          this.$toast.success("Berhasil menambahkan data");
          loading.hide();
          this.createModalBatch = false;
          this.batch = {
            tahap_balap_id: '', 
            nomor_batch: '',
            kapasitas_gate: '',
            status_batch: "TERJADWAL"
          }
          this.getDataTahapBalap(this.params.category_id);
        })
        .catch(() => {
          loading.hide();
        });
    },
    editModalBatch(data) {
      this.isUpdateBatch = true;
      this.createModalBatch = true;
      this.batch = data
    },
    addModalBatch(data) {
      this.isUpdateBatch = false;
      this.createModalBatch = true;
      this.batch = {
        tahap_balap_id: data.id, 
        nomor_batch: '',
        kapasitas_gate: '',
        status_batch: "TERJADWAL"
      }
    },
    cancel() {
      this.form = {
        category_id: this.params.category_id,
        nama_tahap: '',
        urutan_tahap: '',
        jumlah_batch: '',
        moto_per_batch: '',
        lolos_per_batch: ''
      };
      this.createModal = false;
    },
    submit() {
      this.form.category_id = this.params.category_id
      var loading = this.$loading.show();
      this.$store
        .dispatch("race/addTahapBalap", this.form)
        .then(() => {
          this.$toast.success("Berhasil menambahkan data");
          loading.hide();
          this.createModal = false;
          this.form = {
            category_id: this.params.category_id,
            nama_tahap: '',
            urutan_tahap: '',
            jumlah_batch: '',
            moto_per_batch: '',
            lolos_per_batch: ''
          };
          this.getDataTahapBalap(this.params.category_id);
        })
        .catch(() => {
          loading.hide();
        });
    },
    update() {
      this.form.category_id = this.params.category_id
      var loading = this.$loading.show();
      this.$store
        .dispatch("race/editTahapBalap", this.form)
        .then(() => {
          this.$toast.success("Berhasil mengedit data");
          loading.hide();
          this.createModal = false;
          this.form = {
            category_id: this.params.category_id,
            nama_tahap: '',
            urutan_tahap: '',
            jumlah_batch: '',
            moto_per_batch: '',
            lolos_per_batch: ''
          };
          console.log(this.params.category_id, "category");
          this.getDataTahapBalap(this.params.category_id);
        })
        .catch(() => {
          loading.hide();
        });
    },
    editModal(data) {
      this.isUpdate = true;
      this.form = {
        id: data.id,
        nama_tahap: data.nama_tahap,
        urutan_tahap: data.urutan_tahap,
        jumlah_batch: data.jumlah_batch,
        moto_per_batch: data.moto_per_batch,
        lolos_per_batch: data.lolos_per_batch
      }
      this.createModal = true;
    },
    addModal() {
      this.isUpdate = false;
      this.form = {
        nama_tahap: '',
        urutan_tahap: '',
        jumlah_batch: '',
        moto_per_batch: '',
        lolos_per_batch: ''
      }
      this.createModal = true;
    },
    getDataTahapBalap(category_id) {
      const loading = this.$loading.show();
      this.form.category_id = category_id;
      this.$store
        .dispatch("race/getByCategory", category_id || this.params.category_id)
        .then((resp) => {
          this.tahap_balaps = resp;
          this.params.tahap_balap = this.tahap_balaps[0].id;
          this.batches = this.tahap_balaps[0].batches;
          this.params.batch = this.batches[0].id
          loading.hide();
          this.getRegistran();
        })
        .catch((e) => {
          this.$toast.error("Gagal mengambil data: \n" + e);
          loading.hide();
        });
    },
    getDataBatches(tahap_balap_id) {
      const loading = this.$loading.show();
      this.form.category_id = category_id;
      this.$store
        .dispatch("race/getByCategory", category_id || this.params.category_id)
        .then((resp) => {
          this.tahap_balaps = resp;
          this.params.tahap_balap = this.tahap_balaps[0].id;
          this.batches = this.tahap_balaps[0].batches;
          this.params.batch = this.batches[0].id
          loading.hide();
          this.getRegistran();
        })
        .catch((e) => {
          this.$toast.error("Gagal mengambil data: \n" + e);
          loading.hide();
        });
    },
    getDataCategory() {
      const loading = this.$loading.show();
      const params = {
        sorttype: "desc",
        sortby: "id",
        row: 1000,
        page: 1,
        type: [0, 1],
        keyword: "",
        event_id: this.params.event_id
      };
      this.$store
        .dispatch("category/getCategoryList", params)
        .then((resp) => {
          this.categories = resp.data.data;
          this.params.category_id = this.categories[0]?.id || "";
          this.form.category_id = this.categories[0]?.id;
          this.getDataTahapBalap();
          this.getRegistran();
          loading.hide();
        })
        .catch((e) => {
          this.$toast.error("Gagal mengambil data: \n" + e);
          loading.hide();
        });
    },
    getEvents() {
      const loading = this.$loading.show();
      const params = {
        sorttype: "desc",
        sortby: "id",
        row: 1000,
        page: 1,
        type: [0, 1],
        keyword: ""
      };
      this.$store
        .dispatch("event/getEventList", params)
        .then((resp) => {
          this.events = resp.data.data;
          this.params.event_id = this.events[0]?.id || "";
          this.getDataCategory();
          loading.hide();
        })
        .catch((e) => {
          this.$toast.error("Gagal mengambil data: \n" + e);
          loading.hide();
        });
    },
    getMoto(list, nomor) {
      if (!Array.isArray(list)) return null;
      return list.find((item) => item.nomor_moto === nomor) || null;
    },
  },
  computed: {
    computedRegistran() {
      return this.items.map((item) => {
        return {
          value: item.id,
          label: item.fullname,
        };
      });
    },
  },
  mounted() {
    this.getEvents();
  },
};
</script>